<template>
  <modal
    name="loyaltyProgramDetailsModal"
    modal-style="compact"
    :display-header-title="false"
  >
    <loyalty-program-details />
  </modal>
</template>


<script>
  import LoyaltyProgramDetails from './loyalty-program-details/index.vue';


  export default {
    name: 'LoyaltyProgramDetailsModal',

    components: {
      LoyaltyProgramDetails
    }
  };
</script>
